import { render } from "./RepDshSummary.vue?vue&type=template&id=4e5efe09"
import script from "./RepDshSummary.vue?vue&type=script&lang=js"
export * from "./RepDshSummary.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__